import { render } from "./FestivalForm.vue?vue&type=template&id=48d0dada&scoped=true"
import script from "./FestivalForm.vue?vue&type=script&lang=js"
export * from "./FestivalForm.vue?vue&type=script&lang=js"

import "./FestivalForm.vue?vue&type=style&index=0&id=48d0dada&scoped=true&lang=css"

import exportComponent from "C:\\Users\\lenovo\\Desktop\\canadianlic\\client\\app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48d0dada"]])

export default __exports__